export default {
  order: 3,
  layerGroupId: 'GROUP_CLIMATE',
  dataLayer: {
    id: 'DRY_SPELLS',
    order: 3,
    type: 'remoteDataLayer',
    uuid: '41936f95-094b-4ad9-8b8a-70fc159bd0ba',
    groupId: 'GROUP_CLIMATE',
  },
  layer: {
    metadata: {
      colormap: null,
      inputRange: null,
      legendConfig: {
        name: {
          en: '2030 Projected Change in Dry Spells',
          es: '2030 Cambio proyectado en los periodos de sequía',
          fr: '2030 Changement prévu des périodes de sécheresse',
          id: '2030 Proyeksi Perubahan Musim Kering',
          ka: '2030 Projected Change in Dry Spells',
          pt: '2030 Mudança Projetada em Feitiços Secos',
          zh: '2030年预测的旱季变化',
        },
        type: 'gradient',
        items: [
          {
            color: 'rgb(5, 113, 176)',
            name: {
              en: '0×',
              fr: '0×',
              es: '0×',
              pt: '0×',
              id: '0×',
              zh: '0×',
              ka: '0×',
            },
          },
          {
            color: 'rgb(146, 197, 222)',
            name: {
              en: '0.5×',
              fr: '0.5×',
              es: '0.5×',
              pt: '0.5×',
              id: '0.5×',
              zh: '0.5×',
              ka: '0.5×',
            },
          },
          {
            color: 'rgb(247, 247, 247)',
            name: {
              en: '1×',
              fr: '1×',
              es: '1×',
              pt: '1×',
              id: '1×',
              zh: '1×',
              ka: '1×',
            },
          },
          {
            color: 'rgb(232, 61, 88)',
            name: {
              en: '≥2×',
              fr: '≥2×',
              es: '≥2×',
              pt: '≥2×',
              id: '≥2×',
              zh: '≥2×',
              ka: '≥2×',
            },
          },
        ],
      },
      interactionConfig: {},
      outputRange: null,
    },
    id: 'DRY_SPELLS',
    type: 'base-tile-layer',
    url: 'https://tiles.globalforestwatch.org/nexgddp_change_dry_spells_2000_2080/v20211015/Change_Num_Dry_Spells_2030/{z}/{x}/{y}.png',
    technicalName: 'nexgddp_change_dry_spells_2000_2080',
    label: {
      en: 'Projected Change in Dry Spells',
      es: 'Proyección de cambio en los periodos de sequía',
      fr: 'Évolution prévue des périodes de sécheresse',
      id: 'Proyeksi Perubahan Musim Kemarau',
      ka: 'Projected Change in Dry Spells',
      pt: 'Mudança Projetada em Feitiços Secos',
      zh: '旱季的预测变化',
    },
    sublabel: {
      en: '0.25°, global, 2000-2080, WRI/Vizzuality',
      es: '0.25°, global, 2000-2080, WRI/Vizzuality',
      fr: '0,25°, mondial, 2000-2080, WRI/Vizzuality',
      id: '0.25°, global, 2000-2080, WRI/Vizzuality',
      ka: '0.25°, global, 2000-2080, WRI/Vizzuality',
      pt: '0.25°, global, 2000-2080, WRI/Vizzuality',
      zh: '0.25°，全球，2000-2080，WRI/Vizzuality',
    },
  },
  isError: false,
};
